import * as ko from "knockout";
import {IIsSystemPropertyMutable, ISystemMutable} from "./index";
import {MAX_DESCRIPTION_LENGTH, ObjectTypeId} from "../../constants";
import {ISystem} from "../../index";
import mutable_systemaccessinfoHtml from './mutable-systemaccessinfo.html?raw';

export const template = mutable_systemaccessinfoHtml

interface IParams {
    d: ISystem
    md: ISystemMutable
    isPropertyMutable: IIsSystemPropertyMutable
}

export class viewModel {
    private md: ISystemMutable;
    private isPropertyMutable: IIsSystemPropertyMutable;
    private readonly MAX_DESCRIPTION_LENGTH = MAX_DESCRIPTION_LENGTH;
    private readonly ObjectTypeId = ObjectTypeId;
    private readonly d: ISystem

    constructor(private params: IParams) {
        this.d = params.d
        this.md = params.md
        this.isPropertyMutable = params.isPropertyMutable
    }

    private enablePriority = ko.pureComputed(() => {
        return !this.md.multiplerolesamedepartment() && !this.md.multiplerolesamecompany()
    })


}
